import type { ReactNode } from "react";
import type { SxProps } from "@mui/material";
import { ListItem, Tooltip, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Link } from "react-router";
import type { NavigationEntry } from "./models/NavigationEntry";

const listItemButtonStyle: SxProps = {
  borderRadius: 1,
  "&:hover": { backgroundColor: "primary.light" },
  "&.Mui-selected, &.Mui-selected:hover": {
    backgroundColor: "primary.main",
    color: "white",
  },
  "&.Mui-selected .MuiTypography-root": { color: "white" },
};

interface MenuEntryProps {
  navigationEntry: NavigationEntry;
  isOpen: boolean;
  currentPath?: string;
  disableIfNoPath?: boolean;
}

function MenuEntry({
  navigationEntry,
  isOpen,
  currentPath,
  disableIfNoPath = false,
}: Readonly<MenuEntryProps>): ReactNode {
  const { libelle, icon, path } = navigationEntry;
  return (
    <ListItem disablePadding>
      <Tooltip title={libelle} placement="right" disableHoverListener={isOpen}>
        <ListItemButton
          selected={currentPath === path}
          disabled={disableIfNoPath && path == null}
          component={path != null ? Link : "div"}
          to={path}
          sx={listItemButtonStyle}>
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: isOpen ? 2 : "auto",
              color: "inherit",
            }}>
            {icon}
          </ListItemIcon>
          <ListItemText primary={libelle} sx={{ opacity: isOpen ? 1 : 0 }} />
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
}

export default MenuEntry;
